import { isLink } from 'shared/lib'

export const isPicsnippetsUrl = (url: string) => {
  if (!isLink(url)) return false

  const assetUrl = new URL(url)
  return assetUrl.hostname.includes('picsnippets.com')
}
